import { Controller } from 'react-hook-form';

import { MultiChipSelect } from '../../../design/components/MultiChipSelect';

import type { Option } from '../../../design/components/MultiChipSelect';
import type { ReactElement } from 'react';
import type { Control, FieldValues, Path } from 'react-hook-form';

type ReactHookFormMultiChipSelectorProps<T extends FieldValues> = {
    readonly control: Control<T>;
    readonly label: string;
    readonly name: Path<T>;
    readonly options: ReadonlyArray<Option>;
};

export const ReactHookFormMultiChipSelectorField = <T extends FieldValues>({
    control,
    label,
    name,
    options,
}: ReactHookFormMultiChipSelectorProps<T>): ReactElement<any> => (
    <Controller
        control={control}
        name={name}
        render={({ field }) => {
            const toggleOption = (updateOptionKey: string): void => {
                const updatedOptions =
                    field.value?.includes(updateOptionKey) === true
                        ? field.value.filter((key: string) => key !== updateOptionKey)
                        : [...(field.value ?? []), updateOptionKey];

                field.onChange(updatedOptions);
            };

            const optionsWithSelection = options.map((option) => ({
                ...option,
                isSelected: field.value?.includes(option.id),
            }));

            return <MultiChipSelect groupName={label} options={optionsWithSelection} onChange={toggleOption} />;
        }}
    />
);
